module.exports = __webpack_public_path__ + "img/bottom-right-bottom.2dd6adfd.jpg";